import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { accountNumber, password, username, userPassMap } from '../internal.js'

const credentialTypes = [
  username,
  password,
  'auth-token', // Internal use only for overriding auth cache values
] as const
const locationCredentialTypes = [accountNumber] as const

export type cnwyCredType =
  | (typeof credentialTypes)[number]
  | (typeof locationCredentialTypes)[number]

export const cnwyDocumentTypes = [
  'customs-documents',
  'delivery-return-receipt',
  'inspection-certificate',
  'letter-of-authority',
  'nmfc-certificate',
  'proof-of-delivery',
  'signed-bol',
  'weights-and-corrections',
  'weights-and-research-photos',
] as const satisfies readonly DocumentType[]

export const cnwy: CarrierDef<cnwyCredType> = {
  name: 'XPO Logistics',
  scac: 'cnwy',
  credentialTypes,
  locationCredentialTypes,
  ltlServices: [
    { id: 'standard', name: 'Standard' },
    { id: 'guaranteed', name: 'Guaranteed', guaranteed: true },
    {
      id: 'guaranteed_twelve_pm',
      name: 'Guaranteed by Noon',
      guaranteed: true,
      guaranteedByTime: '12:00',
    },
  ],
  legacyCredMap: [...userPassMap, ['account-number', 'ref1']],
  engineLayers: [
    'provisioning',
    'rating',
    'bol',
    'pickup',
    'cancel',
    'tracking',
    'profinder',
    'documents',
    'pickup-status',
  ],
  documentTypes: cnwyDocumentTypes,
  credentialConfig: {
    'account-number': { customerIdentifier: true },
    'auth-token': { hideFromFreightview: true },
  },
}
